import { Form, Button, Input, Select, Message, Modal, DatePicker } from 'ant-design-vue'
import Passenger from './addPassenger.vue'
import SliderVerify from '@/components/slider-verify'
import 'moment/locale/zh-cn'
/* istanbul ignore next */
Passenger.install = function (Vue) {
  Vue.component(Passenger.name, Passenger)
  Vue.use(Input)
  Vue.use(Select)
  Vue.use(Form)
  Vue.use(Button)
  Vue.use(DatePicker)
  Vue.use(Message)
  Vue.use(SliderVerify)
  Vue.prototype.$modal = Modal
}

export default Passenger
